import classNames from "classnames";

interface Props {
    label: string;
    type: "outlined" | "gradient" | "normal"
    handleSubmit?: () => void,
    cName?: string,
}

const Button = ({ label, type, handleSubmit, cName }: Props) => {
    if (type === "gradient")
        return <button onClick={() => !!handleSubmit && handleSubmit()} className={classNames("relative bg-gradient-to-r from-[#E5542F] to-[#8431D6] text-[white] px-3 py-2 rounded-lg font-medium text-xs shadow-lg md:text-sm", cName)} style={{ fontFamily: 'Poppins, sans-serif' }}>
            {label}
        </button>
    else if (type === "outlined")
        return <button onClick={() => !!handleSubmit && handleSubmit()} className="border-3 border-blue-600 text-blue-600 px-[2.5vh] py-2 rounded-lg font-medium text-xs md:text-sm" style={{ fontFamily: 'Poppins, sans-serif', borderWidth: '2px' }}>
            {label}
        </button>
    else
        return <button onClick={() => !!handleSubmit && handleSubmit()}>
            {label}
        </button>
}

export default Button;